<template>
  <div>
    <div class="page-wrapper">
      <div class="silent-auction-section">
        <div class="silent-auction-section__left">
          <h2 class="h2">Help East Lake Grow</h2>
          <p>
            East Lake is many things: a legendary golf course and an
            inspirational community; one of golf’s biggest prizes and one of
            Atlanta’s greatest success stories. During these challenging times,
            the PGA TOUR remains committed to supporting the East Lake
            community, which has served as a national model for responsible and
            sustainable urban renewal. The loss of in-person attendance means we
            need your help more than ever. Though our generous fans have already
            contributed to win some of the amazing rewards below, you can still
            make an impact on East Lake by making a donation today.
          </p>
          <p style="color: red">
            <b
              >100% of the proceeds help benefit East Lake Foundation’s
              important mission!</b
            >
          </p>
        </div>
        <div class="silent-auction-section__right">
          <img src="@/assets/silent-auction/top.jpg" alt="" />
        </div>
      </div>
    </div>

    <div class="silent-auction-items">
      <a
        :style="{ backgroundImage: `url(${item.image})` }"
        class="silent-auction-item"
        v-for="(item, index) in items"
        :key="index"
        :href="item.link_to_all"
        target="_blank"
      >
        <div class="silent-auction-item__content">
          <div class="silent-auction-item__title" v-html="item.title"></div>
          <div class="silent-auction-item__subtitle">{{ item.subtitle }}</div>
        </div>
      </a>
    </div>
    <div class="silent-auction-seeall">
      <v-btn large href="https://e.givesmart.com/events/isQ/i/" target="_blank">
        <span>
          See All
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "SilentAuctionPage",
  data() {
    return {
      loaded: false,
      items: [
        {
          title: "Pebble Beach <br/>Trip for 4",
          subtitle: "",
          image: require("@/assets/silent-auction/1.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bp8W/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "2021 NASCAR Cup Series VIP Access",
          subtitle: "",
          image: require("@/assets/silent-auction/2.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bpsx/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "2021 PGA Championship VIP Tickets",
          subtitle: "",
          image: require("@/assets/silent-auction/3.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bptO/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "Signed 2020 TOUR Championship Pin Flag",
          subtitle: "",
          image: require("@/assets/silent-auction/4.png"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/boyQ/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "Donald Ross Package at Pinehurst Resort",
          subtitle: "",
          image: require("@/assets/silent-auction/5.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bkXQ/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "Coca-Cola UNITED Braves Suite",
          subtitle: "",
          image: require("@/assets/silent-auction/6.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bpsY/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "First-Class Delta Air Lines Tickets",
          subtitle: "",
          image: require("@/assets/silent-auction/7.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bpt0/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
        {
          title: "2021 TOUR Championship Executive Tickets",
          subtitle: "",
          image: require("@/assets/silent-auction/8.jpg"),
          link: "https://e.givesmart.com/events/isQ/i/_Auction/bpuE/",
          link_to_all: "https://e.givesmart.com/events/isQ/i/",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.silent-auction-section {
  display: flex;
  flex-wrap: wrap;
  &__left {
    max-width: 740px;
    padding-right: 20px;
    font-size: 18px;
    line-height: 1.429;
  }

  &__right {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    > img {
      max-width: 100%;
    }
  }
}

.silent-auction-items {
  width: 100%;
  margin-top: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.silent-auction-item {
  background-size: cover;
  background-position: center 0%;
  display: inline-block;
  position: relative;
  flex-basis: calc(25% - 4.5px);
  margin-bottom: 10px;
  &:before {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 103.89%;
  }
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(27, 29, 33, 0) 54.29%,
      #000000 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#a6000000',GradientType=0 ); /* IE6-9 */
  }

  &__content {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: center;
    color: white;
    z-index: 1;
    transition: 1s;
    font-family: Roboto Condensed;
    font-weight: bold;
    filter: drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.5));
  }

  &__subtitle {
    font-weight: bold;
    font-size: 22px;
  }
  &__title {
    font-weight: bold;
    font-size: 2.78vw;
    line-height: 1.1;
    text-transform: capitalize;
    margin: 0.6em 0.6em 0.5em;
  }
}

.silent-auction-seeall {
  display: flex;
  justify-content: center;
  padding: 50px 0 10px 0;
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    color: $primary;
    border: 2px solid $primary;
    box-shadow: none;
  }
}

@media screen and (max-width: 1200px) {
  .silent-auction-item {
    flex-basis: calc(33% - 4px);
    &__title {
      font-size: 3.33vw;
    }
  }
}
@media screen and (max-width: 960px) {
  .silent-auction-item {
    flex-basis: calc(50% - 3px);
    &__title {
      font-size: 4.167vw;
      margin: 0 2em 0.5em;
    }
  }
}
@media screen and (max-width: 700px) {
  .silent-auction-item {
    flex-basis: calc(100%);
    &__title {
      font-size: 10.67vw;
      margin: 0 0.8em 0.5em;
    }
  }
}
</style>
